import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { solutionCatalog } from '../../data/solutions/catalog';
export function RelatedSolutions({
  slugs
}: {
  slugs: string[];
}) {
  const items = slugs.map(s => solutionCatalog[s]).filter(Boolean);
  return <section className="w-full bg-white py-20" aria-labelledby="related-solutions-heading" data-id="element-1544" data-mp="2azymhj0yn0tz">
      <div className="mx-auto max-w-shell px-6" data-id="element-1545" data-mp="1e9o5rqvzk34c">
        <h2 id="related-solutions-heading" className="display text-[30px] font-semibold text-ink sm:text-[40px]" data-id="element-1546" data-mp="1eazabsx99ewi">
          Related solutions
        </h2>
        <ul className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-1547" data-mp="1n9b6sbksz6wv">
          {items.map(item => <li key={item.slug} data-id="element-1548" data-mp="1s97d4hgz3afl">
              <SmartLink href={item.href} className="group flex h-full flex-col" data-id="element-1549" data-mp="1sa8q4rhju6zy">
                <div className="overflow-hidden rounded-[12px]" data-id="element-1550" data-mp="2yo81o23o4qc5">
                  <img src={item.image} alt="" loading="lazy" className="h-[200px] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-1551" data-mp="33nkxvdgfj9re" />
                </div>
                <p className="mt-5 text-[12.5px] font-medium text-ink-muted" data-id="element-1552" data-mp="2d4q9ck8kzz5x">
                  {item.kind === 'industry' ? 'Industry' : 'Business need'}
                </p>
                <h3 className="mt-1 text-[19px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1553" data-mp="2889k1mpnber9">{item.title}</h3>
                <p className="mt-2 text-[15px] leading-[1.5] text-ink-muted" data-id="element-1554" data-mp="238n435ifnker">{item.copy}</p>
                <span className="mt-auto inline-flex items-center gap-1.5 pt-4 text-[15px] font-medium text-brand" data-id="element-1555" data-mp="1ye97x0vy5991">
                  Explore solution
                  <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1556" data-mp="1pggphnuxhlhf" />
                </span>
              </SmartLink>
            </li>)}
        </ul>
      </div>
    </section>;
}